import { render, staticRenderFns } from "./DetalhesComunicacaoEletronica.vue?vue&type=template&id=43c00218&scoped=true"
import script from "./DetalhesComunicacaoEletronica.vue?vue&type=script&lang=js"
export * from "./DetalhesComunicacaoEletronica.vue?vue&type=script&lang=js"
import style0 from "./DetalhesComunicacaoEletronica.vue?vue&type=style&index=0&id=43c00218&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c00218",
  null
  
)

export default component.exports